export default __webpack_public_path__ + "SolutionImage.44a9b4a.png";